import { render } from "./profileSettings.vue?vue&type=template&id=4aed4a8c&scoped=true"
import script from "./profileSettings.js?vue&type=script&lang=js"
export * from "./profileSettings.js?vue&type=script&lang=js"

import "./profileSettings.vue?vue&type=style&index=0&id=4aed4a8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aed4a8c"]])

export default __exports__